import { createFileRoute } from "@tanstack/react-router";
import Terms from "@/pages/Terms";
export const Route = createFileRoute("/terms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Terms of Service | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Read the Terms of Service for Neuro Wellness TMS Centers of America. Learn the terms and conditions governing use of our website and services.",
        },
        {
          property: "og:title",
          content: "Terms of Service | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Read the Terms of Service for Neuro Wellness TMS Centers of America. Learn the terms and conditions governing use of our website and services.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/terms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/terms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <Terms />;
}
